<template>
    <div>
        <div class="rate_box">
            <div class="rate_box_title">佣金率选择</div>
            <el-table :data="settlement" @row-click="handleSettlementRowClick">
                <el-table-column width="55px">
                    <template slot-scope="scope">
                        <el-icon class="el-icon-success" v-if="scope.row.id === settlementId" style="font-size: 20px;color: #409eff;"></el-icon>
                        <el-icon color="#409EFC" class="el-icon-circle-check" v-else style="font-size: 20px;"></el-icon>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="id" width="100px" />
                <el-table-column prop="name" label="名称" width="200px" />
                <el-table-column label="佣金率">
                    <template slot-scope="scope">
                        <div class="rate-box">
                            <span>默认：{{ forMatterRate(scope.row.rates.default) }}</span>
                            <span>YB：{{ forMatterRate(scope.row.rates.iyunfu) }}</span>
                            <span>HZ：{{ forMatterRate(scope.row.rates.qixin) }}</span>
                            <span>YS：{{ forMatterRate(scope.row.rates.niubao) }}</span>
                            <span>WT：{{ forMatterRate(scope.row.rates.fengqi) }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="rate_box_title">税率</div>
            <el-table :data="tax" @row-click="handleTaxRowClick">
                <el-table-column width="55px">
                    <template slot-scope="scope">
                        <el-icon class="el-icon-success" v-if="scope.row.id === taxId" style="font-size: 20px;color: #409eff;"></el-icon>
                        <el-icon color="#409EFC" class="el-icon-circle-check" v-else style="font-size: 20px;"></el-icon>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="id" width="100px" />
                <el-table-column prop="name" label="名称" width="200px" />
                <el-table-column label="佣金率">
                    <template slot-scope="scope">
                        <div class="rate-box">
                            <span>{{ forMatterRate(scope.row.rate) }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;margin-top: 20px;">
            <el-button type="info" size="small" @click="handleCloseSettingRateDialog">取消</el-button>
            <el-button type="primary" size="small" @click="dialogVisible = !dialogVisible">保存</el-button>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
            :modal-append-to-body="true" append-to-body
        >
            <span>确认保存此次修改吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = !dialogVisible">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import request from "@/api/request";

export default {
    props: {
        userId: String
    },
    data(){
        return {
            dialogVisible: false,
            settlement: [],
            tax: [],
            settlementId: null,
            taxId: null
        }
    },
    watch: {
        userId(n){
            if(n) {
                this.getRate()
            }
        }
    },
    mounted() {
        this.getRate()
    },
    methods: {
        getRate(){
            request.saas
                .post('settlement/get_user_settlement_config', {
                    user_id: this.userId
                })
                .then(res => {
                    this.taxId = res.data.tax_rate_template.id
                    this.settlementId = res.data.settlement_rate_template.id
                })
            request.saas
                .post('settlement/get_settlement_rate_template_list', {
                    range: [0, 50],
                })
                .then(r => {
                    this.settlement = r.data.list
                })
            request.saas
                .post('settlement/get_tax_rate_template_list', {
                    range: [0, 50],
                })
                .then(r => {
                    this.tax = r.data.list
                })
        },
        save(){
            //设置佣金率和税率
            let data = {
                user_id: this.userId,
                settlement_rate_template_id: this.settlementId,
                tax_rate_template_id: this.taxId
            }
            request.saas
                .post('settlement/update_user_settlement_config', data)
                .then(() => {
                    this.$message.success('修改成功')
                    this.$emit('handleCloseSettingRateDialog')
                    this.dialogVisible = !this.dialogVisible
                    this.dialogShow = !this.dialogShow
                    this.detailDialogShow = !this.detailDialogShow
                    //this.loadData(this.currentRange)
                })
        },
        handleCloseSettingRateDialog(){
            this.$emit('handleCloseSettingRateDialog')  
        },
        forMatterRate(rate){
            return (rate/100).toFixed(2) + '%'
        },
        handleSettlementRowClick(row){
            this.settlementId = row.id
        },
        handleTaxRowClick(row){
            this.taxId = row.id
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
    }
}
</script>
<style scoped>
.rate_box_title{
    margin: 10px 0;
    font-weight: 500;
    font-size: 16px;
}
.rate-box span{
    margin-right: 10px;
}
</style>
